import { render, staticRenderFns } from "./Marrakesh.vue?vue&type=template&id=2b1b3ee6&"
import script from "./Marrakesh.vue?vue&type=script&lang=js&"
export * from "./Marrakesh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports